import React from 'react'

const Tag = (props) => {
  return (
    <div className="text-white bg-grayscale-lighter rounded-sm inline-block text-sm mb-1 mr-1 p-1 cursor-crosshair">{props.children}</div>
  );
};

export default Tag;
